import React from 'react';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Button, Tooltip } from 'antd';
import { Standard } from 'components/Page';
import { history } from 'store';
import { defaultSettings } from 'views/Roster/timeline/config';
import config from './config';

const RosterBuilders = ({ permissions }) => (
  <Standard
    classes="bhp-rosterBuilder"
    canAdmin={permissions.CanAdminActivities()
      .hasPermissions()}
    reducer={{
      item: REDUCER_KEY.rosterBuilder,
      list: REDUCER_KEY.rosterBuilders
    }}
    scroll={{
      x: 800,
      y: '100%'
    }}
    config={{
      ...config,
      detail: {
        ...config.detail,
        commands: {
          showSaveButton: permissions.CanAdminActivities()
            .hasPermissions(),
          otherButtons: item => permissions.CanAdminActivities()
            .hasPermissions() && (
            <>
              <Tooltip title="Manage Timeline" placement="bottom">
                <Button type="primary" size="small" disabled={false} icon="save" onClick={() => history.push(`/roster/rosterBuilders/timeline/${item.id}`)}>
                  Manage Timeline
                </Button>
              </Tooltip>
            </>
          )
        }
      }
    }}
    defaultSettings={defaultSettings.filters.activity}
    filterSettings={{
      reducerKey: 'rosterBuilderCollectionValues',
      placeholder: 'roster builder details',
      themeName: 'rosterbuilder',
      showClearButton: false
    }}
  />
);

RosterBuilders.propTypes = {
  permissions: PropTypes.object.isRequired,
};

export default RosterBuilders;
